import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["oncontextmenu"]
const _hoisted_2 = { class: "flex justify-between pb-2" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "text-lg font-bold"
}
const _hoisted_5 = { class: "-mr-2 -mt-2 ml-4 flex" }
const _hoisted_6 = ["title", "data-src"]
const _hoisted_7 = ["disablePictureInPicture", "src", "muted", "controlsList"]

import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import {
  youtubeVideoUrlRegex,
} from 'utilities';
import {
  extractYoutubeVideoId,
} from '@/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoModal',
  props: {
  videoUrl: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  boxClass: {
    type: String,
    default: 'max-w-screen-lg',
  },
  isMuted: {
    type: Boolean,
    default: false,
  },
  allowMoreOption: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "video-modal",
    class: "modal modal-open",
    oncontextmenu: `return ${__props.allowMoreOption};`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-box relative", __props.boxClass])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-circle border-0 font-bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "size-6 text-violet-600" })
          ])
        ])
      ]),
      (_unref(youtubeVideoUrlRegex).test(__props.videoUrl))
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 0,
            title: __props.title,
            "data-src": `https://www.youtube-nocookie.com/embed/${_unref(extractYoutubeVideoId)(__props.videoUrl)}`,
            class: "lazyload aspect-[16/9] w-full bg-blue-100",
            frameborder: "0",
            allow: "accelerometer; autoplay; encrypted-media; gyroscope;",
            allowfullscreen: ""
          }, null, 8, _hoisted_6))
        : (_openBlock(), _createElementBlock("video", {
            key: 1,
            ref: "video",
            disablePictureInPicture: !__props.allowMoreOption,
            src: __props.videoUrl,
            muted: __props.isMuted,
            controlsList: __props.allowMoreOption ? '' : 'nodownload noplaybackrate',
            type: "video/mp4",
            class: "mt-2 h-full w-full rounded",
            preload: "auto",
            crossorigin: "anonymous",
            autoplay: "",
            controls: ""
          }, null, 8, _hoisted_7))
    ], 2)
  ], 8, _hoisted_1))
}
}

})